<template>
  <li class="list-group-item d-flex">
    <div class="col">
      <router-link :to="{name: 'ListImages', query: { owner_type: owner_type, owner_id: owner_id, site_id: site_id } }" class="btn btn-sm float-start">
        <show-icon name="image" size="sm" class="align-middle"></show-icon>&nbsp;{{t('models.image', 2)}}
      </router-link>
      <span class="badge bg-primary rounded-pill">{{nbImages}}</span>
    </div>
    <div class="col">
      <router-link :to="{name: 'ListImages', query: { owner_type: owner_type, owner_id: owner_id, site_id: site_id, take_photo: 1 } }" role="button" class="btn btn-xs float-end">
        <show-icon name="photo_camera" size="sm" class="align-middle"></show-icon>
        <span class="d-none d-sm-inline align-middle">&nbsp;{{ $t('take_photo') }}</span>
      </router-link>
    </div>
  </li>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n({ useScope: 'global' });
    return {
      t
    }     
  },
  props: [
    "owner_type",
    "owner_id",
    "site_id"
  ],
  computed: {
    nbImages() {
      if (this.owner_type == "Site") {
        return this.$store.getters.allImagesBySiteUUID(this.owner_id).length;
      } else {
        return this.$store.getters.allImagesByOwner(this.owner_id).length;
      }
    }    
  }
}
</script>